import { ConversationFormValues } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { openComposeEmail } from 'app/components/appModals/components/composeEmailModal/openComposeEmail';
import { getPhoneCallAvailability } from 'components/telephony/utils/phoneCallAvailability';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { actions as personalActions } from '../../settings/actions/personal';
import { hasFeature } from '../../shared/featureFlag';
import { actions } from '../actions/conversation';
import ReplySection from '../components/ReplySection';
import { elevioActions } from '../components/integrations/elevio/src/elevio.actions';
import { getLatestFacebookConversation } from '../selectors';
import { getConversationFormName } from '../utils/conversationForm';

const mapStateToProps = (state) => {
  const csid = state.conversation.metaConversation.conversation.id;
  const metaConversation = state.conversation.metaConversation;
  const { canMakePhoneCall, selectedFromNumber } =
    getPhoneCallAvailability(state);

  const form = getConversationFormName(csid);
  const formValues: ConversationFormValues = getFormValues(form)(state);

  return {
    channel: metaConversation.conversation.initial_channel,
    csid: csid,
    isAssignedToMe: metaConversation.isAssignedToMe,
    selectFromEmail: formValues?.fromEmail ?? null,
    live_assesment: metaConversation.conversation.live_assesment,
    makeCallAsyncStatus: state.twilio.meta.makeCall,
    canMakeOutBoundCall: canMakePhoneCall,
    telephonyFromNumber: selectedFromNumber,
    isClosed: metaConversation.conversation.is_closed,
    isResolved: !!metaConversation.conversation.resolution?.resolvedAt,
    metaConversation: metaConversation,
    requester: metaConversation.requester,
    replyAreaHeight: state.settings.personal.replyAreaHeight,
    hasFFWriteHTMLEmail: hasFeature(state, 'write-html-email'),
    rewrittenHtmlEmailMessages: state.emailMessages.messages.filter(
      (m) => m.csid === csid,
    ),
    latestMessengerConversation: getLatestFacebookConversation(state),
    tempCurrentTab: metaConversation.tempCurrentTab,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    conversationClaim: bindActionToPromise(dispatch, actions.conversationClaim),
    telephonyMakeCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeCall,
    ),
    composeEmailOpenModal: (payload) => dispatch(openComposeEmail(payload)),
    updateReplyAreaHeight: bindActionToPromise(
      dispatch,
      personalActions.personalReplyAreaHeight,
    ),
    updateCurrentTabStatus: (payload: {
      csid: number;
      tabStatus: 'reply' | 'note';
    }) => {
      dispatch(elevioActions.smartReply.updateReplySectionTabStatus(payload));
      dispatch(
        actions.conversationSaveTempCurrentTab({
          csid: payload.csid,
          currentTab: payload.tabStatus,
        }),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplySection);
